import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectIsNewChatFromLinkOpened } from '../../../selectors/newChatFromLinkOpenedSelector';
import { ca } from '@cian/analytics';

/**
 * @description
 * Отправляет аналитику на открытие нового чата по ссылке /new-chat/
 */
export const useChatsLinkAnalytics = () => {
  const isNewChatFromLinkOpened = useSelector(selectIsNewChatFromLinkOpened);

  useEffect(() => {
    if (!isNewChatFromLinkOpened) {
      return;
    }

    ca('eventSite', {
      name: 'oldevent',
      category: 'Chat',
      action: 'deep_link_opened',
      label: 'deeplink',
    });
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
